module.exports = __webpack_public_path__ + "img/f1-defense.a91a37eb.png";